import { SourceOfFundsType } from 'constants/loanApplication';
import { getConditionalObject } from 'utils/data';

import { deferredThreshold } from './AdditionalMortgageForm.constants';

export const normalizeForm = ({ form, fieldKey }) => {
  const {
    sourceOfFunds,
    monthsDeferred,
    heloc,
    otherFundDescription,
    deferredType,
    highLimit,
    isAffordableLoan,
    ...rest
  } = form.additionalMortgages?.[fieldKey] ?? {};

  const isOtherSourceOfFunds = sourceOfFunds?.value === SourceOfFundsType.OTHER;
  const isDeferredThreshold = monthsDeferred >= deferredThreshold;

  const updatedAdditionalMortgages = { ...form.additionalMortgages };

  const updatedCurrentAdditionalMortgageForm = {
    sourceOfFunds,
    ...getConditionalObject(isOtherSourceOfFunds, {
      otherFundDescription,
    }),
    monthsDeferred,
    ...getConditionalObject(isDeferredThreshold, {
      deferredType,
    }),
    heloc,
    ...getConditionalObject(heloc, {
      highLimit,
    }),
    ...getConditionalObject(!heloc, {
      isAffordableLoan,
    }),
    ...rest,
  };

  updatedAdditionalMortgages[fieldKey] = updatedCurrentAdditionalMortgageForm;

  return {
    ...form,
    additionalMortgages: updatedAdditionalMortgages,
  };
};
